export default "__VITE_ASSET__0707f446__"